















import Vue, { PropType } from 'vue';
import { Cv, CvSectionText } from '@/../gen';
// @ts-ignore
import SectionPreviewField from '@/components/section-preview/SectionPreviewField.vue';

export default Vue.extend({
  components: {
    SectionPreviewField,
  },
  props: {
    cv: {
      type: Object as PropType<Cv>,
      required: true,
    },
    section: {
      type: Object as PropType<CvSectionText>,
      required: true,
    },
  },
});
